import { getDiffRouteTime, report, stReportSdk } from './report';

stReportSdk.trackPageLoad();

report({
  eventName: 'load_page_start',
  eventDescription: '页面加载',
  eventDataValue: {
    td_pl: getDiffRouteTime()
  }
});
